// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { fieldMaskFromJson, fieldMaskToJson, pagedRequestOptionsFromJson, pagedRequestOptionsToJson, pagedResponseMetadataFromJson, pagedResponseMetadataToJson } from '../../vendastatypes/codec';
function decodeInt64(v) {
    return typeof v === 'string' ? Number(v) : v;
}
export function privacyToJson(m) {
    const o = {};
    if (m.internalMeetings !== undefined)
        o['internalMeetings'] = m.internalMeetings;
    if (m.externalMeetings !== undefined)
        o['externalMeetings'] = m.externalMeetings;
    return o;
}
export function privacyFromJson(o) {
    var _a, _b;
    return {
        internalMeetings: (_a = o['internalMeetings']) !== null && _a !== void 0 ? _a : 'PRIVACY_LEVEL_UNSPECIFIED',
        externalMeetings: (_b = o['externalMeetings']) !== null && _b !== void 0 ? _b : 'PRIVACY_LEVEL_UNSPECIFIED',
    };
}
export function externalAttendeeToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.phoneNumber !== undefined)
        o['phoneNumber'] = m.phoneNumber;
    if (m.contactId !== undefined)
        o['contactId'] = m.contactId;
    return o;
}
export function externalAttendeeFromJson(o) {
    var _a, _b, _c, _d;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        email: (_b = o['email']) !== null && _b !== void 0 ? _b : '',
        phoneNumber: (_c = o['phoneNumber']) !== null && _c !== void 0 ? _c : '',
        contactId: (_d = o['contactId']) !== null && _d !== void 0 ? _d : '',
    };
}
export function wordsToJson(m) {
    const o = {};
    if (m.text !== undefined)
        o['text'] = m.text;
    if (m.startTime !== undefined)
        o['startTime'] = m.startTime;
    if (m.endTime !== undefined)
        o['endTime'] = m.endTime;
    return o;
}
export function wordsFromJson(o) {
    var _a, _b, _c;
    return {
        text: (_a = o['text']) !== null && _a !== void 0 ? _a : '',
        startTime: (_b = o['startTime']) !== null && _b !== void 0 ? _b : 0,
        endTime: (_c = o['endTime']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function transcriptEntryToJson(m) {
    const o = {};
    if (m.displayName !== undefined)
        o['displayName'] = m.displayName;
    if (m.words !== undefined) {
        o['words'] = m.words.map(e => wordsToJson(e));
    }
    return o;
}
export function transcriptEntryFromJson(o) {
    var _a, _b;
    return {
        displayName: (_a = o['displayName']) !== null && _a !== void 0 ? _a : '',
        words: ((_b = o['words']) !== null && _b !== void 0 ? _b : []).map(e => wordsFromJson(e)),
    };
}
export function topicToJson(m) {
    const o = {};
    if (m.topic !== undefined)
        o['topic'] = m.topic;
    if (m.topicDuration !== undefined)
        o['topicDuration'] = m.topicDuration;
    if (m.keyTakeaways !== undefined) {
        o['keyTakeaways'] = m.keyTakeaways.map(e => keyTakeawayToJson(e));
    }
    return o;
}
export function topicFromJson(o) {
    var _a, _b, _c;
    return {
        topic: (_a = o['topic']) !== null && _a !== void 0 ? _a : '',
        topicDuration: (_b = o['topicDuration']) !== null && _b !== void 0 ? _b : 0,
        keyTakeaways: ((_c = o['keyTakeaways']) !== null && _c !== void 0 ? _c : []).map(e => keyTakeawayFromJson(e)),
    };
}
export function keyTakeawayToJson(m) {
    const o = {};
    if (m.keyTakeaway !== undefined)
        o['keyTakeaway'] = m.keyTakeaway;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp;
    return o;
}
export function keyTakeawayFromJson(o) {
    var _a, _b;
    return {
        keyTakeaway: (_a = o['keyTakeaway']) !== null && _a !== void 0 ? _a : '',
        timestamp: (_b = o['timestamp']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function actionItemToJson(m) {
    const o = {};
    if (m.owner !== undefined)
        o['owner'] = m.owner;
    if (m.item !== undefined)
        o['item'] = m.item;
    return o;
}
export function actionItemFromJson(o) {
    var _a, _b;
    return {
        owner: (_a = o['owner']) !== null && _a !== void 0 ? _a : '',
        item: (_b = o['item']) !== null && _b !== void 0 ? _b : '',
    };
}
export function highlightToJson(m) {
    const o = {};
    if (m.highlight !== undefined)
        o['highlight'] = m.highlight;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp;
    return o;
}
export function highlightFromJson(o) {
    var _a, _b;
    return {
        highlight: (_a = o['highlight']) !== null && _a !== void 0 ? _a : '',
        timestamp: (_b = o['timestamp']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function lowlightToJson(m) {
    const o = {};
    if (m.lowlight !== undefined)
        o['lowlight'] = m.lowlight;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp;
    return o;
}
export function lowlightFromJson(o) {
    var _a, _b;
    return {
        lowlight: (_a = o['lowlight']) !== null && _a !== void 0 ? _a : '',
        timestamp: (_b = o['timestamp']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function keywordToJson(m) {
    const o = {};
    if (m.keyword !== undefined)
        o['keyword'] = m.keyword;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp;
    return o;
}
export function keywordFromJson(o) {
    var _a, _b;
    return {
        keyword: (_a = o['keyword']) !== null && _a !== void 0 ? _a : '',
        timestamp: (_b = o['timestamp']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function questionToJson(m) {
    const o = {};
    if (m.question !== undefined)
        o['question'] = m.question;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp;
    return o;
}
export function questionFromJson(o) {
    var _a, _b;
    return {
        question: (_a = o['question']) !== null && _a !== void 0 ? _a : '',
        timestamp: (_b = o['timestamp']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function businessInfoToJson(m) {
    const o = {};
    if (m.numberOfEmployees !== undefined)
        o['numberOfEmployees'] = m.numberOfEmployees;
    if (m.revenue !== undefined)
        o['revenue'] = m.revenue;
    if (m.locations !== undefined)
        o['locations'] = m.locations;
    if (m.decisionMakers !== undefined)
        o['decisionMakers'] = m.decisionMakers;
    return o;
}
export function businessInfoFromJson(o) {
    var _a, _b, _c, _d;
    return {
        numberOfEmployees: (_a = decodeInt64(o['numberOfEmployees'])) !== null && _a !== void 0 ? _a : 0,
        revenue: (_b = decodeInt64(o['revenue'])) !== null && _b !== void 0 ? _b : 0,
        locations: (_c = decodeInt64(o['locations'])) !== null && _c !== void 0 ? _c : 0,
        decisionMakers: (_d = decodeInt64(o['decisionMakers'])) !== null && _d !== void 0 ? _d : 0,
    };
}
export function needToJson(m) {
    const o = {};
    if (m.need !== undefined)
        o['need'] = m.need;
    if (m.reason !== undefined)
        o['reason'] = m.reason;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp;
    return o;
}
export function needFromJson(o) {
    var _a, _b, _c;
    return {
        need: (_a = o['need']) !== null && _a !== void 0 ? _a : '',
        reason: (_b = o['reason']) !== null && _b !== void 0 ? _b : '',
        timestamp: (_c = o['timestamp']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function painPointToJson(m) {
    const o = {};
    if (m.painPoint !== undefined)
        o['painPoint'] = m.painPoint;
    if (m.reason !== undefined)
        o['reason'] = m.reason;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp;
    return o;
}
export function painPointFromJson(o) {
    var _a, _b, _c;
    return {
        painPoint: (_a = o['painPoint']) !== null && _a !== void 0 ? _a : '',
        reason: (_b = o['reason']) !== null && _b !== void 0 ? _b : '',
        timestamp: (_c = o['timestamp']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function sellingOpportunityToJson(m) {
    const o = {};
    if (m.opportunity !== undefined)
        o['opportunity'] = m.opportunity;
    if (m.reason !== undefined)
        o['reason'] = m.reason;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp;
    return o;
}
export function sellingOpportunityFromJson(o) {
    var _a, _b, _c;
    return {
        opportunity: (_a = o['opportunity']) !== null && _a !== void 0 ? _a : '',
        reason: (_b = o['reason']) !== null && _b !== void 0 ? _b : '',
        timestamp: (_c = o['timestamp']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function redFlagToJson(m) {
    const o = {};
    if (m.redFlag !== undefined)
        o['redFlag'] = m.redFlag;
    if (m.reason !== undefined)
        o['reason'] = m.reason;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp;
    return o;
}
export function redFlagFromJson(o) {
    var _a, _b, _c;
    return {
        redFlag: (_a = o['redFlag']) !== null && _a !== void 0 ? _a : '',
        reason: (_b = o['reason']) !== null && _b !== void 0 ? _b : '',
        timestamp: (_c = o['timestamp']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function techStackToJson(m) {
    const o = {};
    if (m.technology !== undefined)
        o['technology'] = m.technology;
    if (m.useCase !== undefined)
        o['useCase'] = m.useCase;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp;
    return o;
}
export function techStackFromJson(o) {
    var _a, _b, _c;
    return {
        technology: (_a = o['technology']) !== null && _a !== void 0 ? _a : '',
        useCase: (_b = o['useCase']) !== null && _b !== void 0 ? _b : '',
        timestamp: (_c = o['timestamp']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function alternativeTechToJson(m) {
    const o = {};
    if (m.alternativeTechnology !== undefined)
        o['alternativeTechnology'] = m.alternativeTechnology;
    if (m.reason !== undefined)
        o['reason'] = m.reason;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp;
    return o;
}
export function alternativeTechFromJson(o) {
    var _a, _b, _c;
    return {
        alternativeTechnology: (_a = o['alternativeTechnology']) !== null && _a !== void 0 ? _a : '',
        reason: (_b = o['reason']) !== null && _b !== void 0 ? _b : '',
        timestamp: (_c = o['timestamp']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function strengthToJson(m) {
    const o = {};
    if (m.observation !== undefined)
        o['observation'] = m.observation;
    if (m.whyItMatters !== undefined)
        o['whyItMatters'] = m.whyItMatters;
    if (m.coachingAdvice !== undefined)
        o['coachingAdvice'] = m.coachingAdvice;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp;
    return o;
}
export function strengthFromJson(o) {
    var _a, _b, _c, _d;
    return {
        observation: (_a = o['observation']) !== null && _a !== void 0 ? _a : '',
        whyItMatters: (_b = o['whyItMatters']) !== null && _b !== void 0 ? _b : '',
        coachingAdvice: (_c = o['coachingAdvice']) !== null && _c !== void 0 ? _c : '',
        timestamp: (_d = o['timestamp']) !== null && _d !== void 0 ? _d : 0,
    };
}
export function talkTimeToJson(m) {
    const o = {};
    if (m.person !== undefined)
        o['person'] = m.person;
    if (m.amount !== undefined)
        o['amount'] = m.amount;
    return o;
}
export function talkTimeFromJson(o) {
    var _a, _b;
    return {
        person: (_a = o['person']) !== null && _a !== void 0 ? _a : '',
        amount: (_b = decodeInt64(o['amount'])) !== null && _b !== void 0 ? _b : 0,
    };
}
export function monologueToJson(m) {
    const o = {};
    if (m.duration !== undefined)
        o['duration'] = m.duration;
    if (m.context !== undefined)
        o['context'] = m.context;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp;
    return o;
}
export function monologueFromJson(o) {
    var _a, _b, _c;
    return {
        duration: (_a = o['duration']) !== null && _a !== void 0 ? _a : 0,
        context: (_b = o['context']) !== null && _b !== void 0 ? _b : '',
        timestamp: (_c = o['timestamp']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function monologueQualityToJson(m) {
    const o = {};
    if (m.hostAssessment !== undefined)
        o['hostAssessment'] = m.hostAssessment;
    if (m.hostReasoning !== undefined)
        o['hostReasoning'] = m.hostReasoning;
    if (m.guestAssessment !== undefined)
        o['guestAssessment'] = m.guestAssessment;
    if (m.guestReasoning !== undefined)
        o['guestReasoning'] = m.guestReasoning;
    return o;
}
export function monologueQualityFromJson(o) {
    var _a, _b, _c, _d;
    return {
        hostAssessment: (_a = decodeInt64(o['hostAssessment'])) !== null && _a !== void 0 ? _a : 0,
        hostReasoning: (_b = o['hostReasoning']) !== null && _b !== void 0 ? _b : '',
        guestAssessment: (_c = decodeInt64(o['guestAssessment'])) !== null && _c !== void 0 ? _c : 0,
        guestReasoning: (_d = o['guestReasoning']) !== null && _d !== void 0 ? _d : '',
    };
}
export function interruptionMetricsToJson(m) {
    const o = {};
    if (m.hostInterruptionsOfGuests !== undefined)
        o['hostInterruptionsOfGuests'] = m.hostInterruptionsOfGuests;
    if (m.guestInterruptionsOfHosts !== undefined)
        o['guestInterruptionsOfHosts'] = m.guestInterruptionsOfHosts;
    if (m.interruptionContextAnalysis !== undefined)
        o['interruptionContextAnalysis'] = m.interruptionContextAnalysis;
    return o;
}
export function interruptionMetricsFromJson(o) {
    var _a, _b, _c;
    return {
        hostInterruptionsOfGuests: (_a = decodeInt64(o['hostInterruptionsOfGuests'])) !== null && _a !== void 0 ? _a : 0,
        guestInterruptionsOfHosts: (_b = decodeInt64(o['guestInterruptionsOfHosts'])) !== null && _b !== void 0 ? _b : 0,
        interruptionContextAnalysis: (_c = decodeInt64(o['interruptionContextAnalysis'])) !== null && _c !== void 0 ? _c : 0,
    };
}
export function interactionReportToJson(m) {
    const o = {};
    if (m.talkTime !== undefined) {
        o['talkTime'] = m.talkTime.map(e => talkTimeToJson(e));
    }
    if (m.questionRate !== undefined)
        o['questionRate'] = m.questionRate;
    if (m.sentimentScore !== undefined)
        o['sentimentScore'] = m.sentimentScore;
    if (m.patience !== undefined)
        o['patience'] = m.patience;
    if (m.longestHostMonologue !== undefined)
        o['longestHostMonologue'] = monologueToJson(m.longestHostMonologue);
    if (m.longestGuestMonologue !== undefined)
        o['longestGuestMonologue'] = monologueToJson(m.longestGuestMonologue);
    if (m.monologueQuality !== undefined)
        o['monologueQuality'] = monologueQualityToJson(m.monologueQuality);
    if (m.interactivityScore !== undefined)
        o['interactivityScore'] = m.interactivityScore;
    if (m.interruptionMetrics !== undefined)
        o['interruptionMetrics'] = interruptionMetricsToJson(m.interruptionMetrics);
    if (m.interactionReportComments !== undefined)
        o['interactionReportComments'] = m.interactionReportComments;
    return o;
}
export function interactionReportFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        talkTime: ((_a = o['talkTime']) !== null && _a !== void 0 ? _a : []).map(e => talkTimeFromJson(e)),
        questionRate: (_b = decodeInt64(o['questionRate'])) !== null && _b !== void 0 ? _b : 0,
        sentimentScore: (_c = decodeInt64(o['sentimentScore'])) !== null && _c !== void 0 ? _c : 0,
        patience: (_d = decodeInt64(o['patience'])) !== null && _d !== void 0 ? _d : 0,
        longestHostMonologue: o['longestHostMonologue'] ? monologueFromJson(o['longestHostMonologue']) : undefined,
        longestGuestMonologue: o['longestGuestMonologue'] ? monologueFromJson(o['longestGuestMonologue']) : undefined,
        monologueQuality: o['monologueQuality'] ? monologueQualityFromJson(o['monologueQuality']) : undefined,
        interactivityScore: (_e = decodeInt64(o['interactivityScore'])) !== null && _e !== void 0 ? _e : 0,
        interruptionMetrics: o['interruptionMetrics'] ? interruptionMetricsFromJson(o['interruptionMetrics']) : undefined,
        interactionReportComments: (_f = o['interactionReportComments']) !== null && _f !== void 0 ? _f : '',
    };
}
export function clarityReportToJson(m) {
    const o = {};
    if (m.pronunciationAndPaceScore !== undefined)
        o['pronunciationAndPaceScore'] = m.pronunciationAndPaceScore;
    if (m.languageSimplicityScore !== undefined)
        o['languageSimplicityScore'] = m.languageSimplicityScore;
    if (m.structureAndOrganizationScore !== undefined)
        o['structureAndOrganizationScore'] = m.structureAndOrganizationScore;
    if (m.activeListeningScore !== undefined)
        o['activeListeningScore'] = m.activeListeningScore;
    if (m.limitedFillersScore !== undefined)
        o['limitedFillersScore'] = m.limitedFillersScore;
    if (m.objectionHandlingScore !== undefined)
        o['objectionHandlingScore'] = m.objectionHandlingScore;
    if (m.scoreReasoning !== undefined)
        o['scoreReasoning'] = m.scoreReasoning;
    if (m.totalScore !== undefined)
        o['totalScore'] = m.totalScore;
    return o;
}
export function clarityReportFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        pronunciationAndPaceScore: (_a = decodeInt64(o['pronunciationAndPaceScore'])) !== null && _a !== void 0 ? _a : 0,
        languageSimplicityScore: (_b = decodeInt64(o['languageSimplicityScore'])) !== null && _b !== void 0 ? _b : 0,
        structureAndOrganizationScore: (_c = decodeInt64(o['structureAndOrganizationScore'])) !== null && _c !== void 0 ? _c : 0,
        activeListeningScore: (_d = decodeInt64(o['activeListeningScore'])) !== null && _d !== void 0 ? _d : 0,
        limitedFillersScore: (_e = decodeInt64(o['limitedFillersScore'])) !== null && _e !== void 0 ? _e : 0,
        objectionHandlingScore: (_f = decodeInt64(o['objectionHandlingScore'])) !== null && _f !== void 0 ? _f : 0,
        scoreReasoning: (_g = o['scoreReasoning']) !== null && _g !== void 0 ? _g : '',
        totalScore: (_h = decodeInt64(o['totalScore'])) !== null && _h !== void 0 ? _h : 0,
    };
}
export function ravenSectionToJson(m) {
    const o = {};
    if (m.score !== undefined)
        o['score'] = m.score;
    if (m.comments !== undefined)
        o['comments'] = m.comments;
    return o;
}
export function ravenSectionFromJson(o) {
    var _a, _b;
    return {
        score: (_a = decodeInt64(o['score'])) !== null && _a !== void 0 ? _a : 0,
        comments: (_b = o['comments']) !== null && _b !== void 0 ? _b : '',
    };
}
export function ravenFrameworkToJson(m) {
    const o = {};
    if (m.rapportAndContext !== undefined)
        o['rapportAndContext'] = ravenSectionToJson(m.rapportAndContext);
    if (m.assessmentAndDiscovery !== undefined)
        o['assessmentAndDiscovery'] = ravenSectionToJson(m.assessmentAndDiscovery);
    if (m.valueDelivery !== undefined)
        o['valueDelivery'] = ravenSectionToJson(m.valueDelivery);
    if (m.engagementAndObjectionHandling !== undefined)
        o['engagementAndObjectionHandling'] = ravenSectionToJson(m.engagementAndObjectionHandling);
    if (m.nextStepsAndOwnership !== undefined)
        o['nextStepsAndOwnership'] = ravenSectionToJson(m.nextStepsAndOwnership);
    if (m.totalScore !== undefined)
        o['totalScore'] = m.totalScore;
    if (m.totalScoreComments !== undefined)
        o['totalScoreComments'] = m.totalScoreComments;
    return o;
}
export function ravenFrameworkFromJson(o) {
    var _a, _b;
    return {
        rapportAndContext: o['rapportAndContext'] ? ravenSectionFromJson(o['rapportAndContext']) : undefined,
        assessmentAndDiscovery: o['assessmentAndDiscovery'] ? ravenSectionFromJson(o['assessmentAndDiscovery']) : undefined,
        valueDelivery: o['valueDelivery'] ? ravenSectionFromJson(o['valueDelivery']) : undefined,
        engagementAndObjectionHandling: o['engagementAndObjectionHandling'] ? ravenSectionFromJson(o['engagementAndObjectionHandling']) : undefined,
        nextStepsAndOwnership: o['nextStepsAndOwnership'] ? ravenSectionFromJson(o['nextStepsAndOwnership']) : undefined,
        totalScore: (_a = decodeInt64(o['totalScore'])) !== null && _a !== void 0 ? _a : 0,
        totalScoreComments: (_b = o['totalScoreComments']) !== null && _b !== void 0 ? _b : '',
    };
}
export function explanationToJson(m) {
    const o = {};
    if (m.explanation !== undefined)
        o['explanation'] = m.explanation;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp;
    return o;
}
export function explanationFromJson(o) {
    var _a, _b;
    return {
        explanation: (_a = o['explanation']) !== null && _a !== void 0 ? _a : '',
        timestamp: (_b = o['timestamp']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function bANTScoresToJson(m) {
    const o = {};
    if (m.budgetScore !== undefined)
        o['budgetScore'] = m.budgetScore;
    if (m.authorityScore !== undefined)
        o['authorityScore'] = m.authorityScore;
    if (m.needScore !== undefined)
        o['needScore'] = m.needScore;
    if (m.timelineScore !== undefined)
        o['timelineScore'] = m.timelineScore;
    if (m.explanations !== undefined) {
        o['explanations'] = m.explanations.map(e => explanationToJson(e));
    }
    return o;
}
export function bANTScoresFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        budgetScore: (_a = decodeInt64(o['budgetScore'])) !== null && _a !== void 0 ? _a : 0,
        authorityScore: (_b = decodeInt64(o['authorityScore'])) !== null && _b !== void 0 ? _b : 0,
        needScore: (_c = decodeInt64(o['needScore'])) !== null && _c !== void 0 ? _c : 0,
        timelineScore: (_d = decodeInt64(o['timelineScore'])) !== null && _d !== void 0 ? _d : 0,
        explanations: ((_e = o['explanations']) !== null && _e !== void 0 ? _e : []).map(e => explanationFromJson(e)),
    };
}
export function mEDPICCScoresToJson(m) {
    const o = {};
    if (m.metricsScore !== undefined)
        o['metricsScore'] = m.metricsScore;
    if (m.economicBuyerScore !== undefined)
        o['economicBuyerScore'] = m.economicBuyerScore;
    if (m.decisionCriteriaScore !== undefined)
        o['decisionCriteriaScore'] = m.decisionCriteriaScore;
    if (m.decisionProcessScore !== undefined)
        o['decisionProcessScore'] = m.decisionProcessScore;
    if (m.paperScore !== undefined)
        o['paperScore'] = m.paperScore;
    if (m.identifyPainScore !== undefined)
        o['identifyPainScore'] = m.identifyPainScore;
    if (m.championScore !== undefined)
        o['championScore'] = m.championScore;
    if (m.explanations !== undefined) {
        o['explanations'] = m.explanations.map(e => explanationToJson(e));
    }
    if (m.competitionScore !== undefined)
        o['competitionScore'] = m.competitionScore;
    return o;
}
export function mEDPICCScoresFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        metricsScore: (_a = decodeInt64(o['metricsScore'])) !== null && _a !== void 0 ? _a : 0,
        economicBuyerScore: (_b = decodeInt64(o['economicBuyerScore'])) !== null && _b !== void 0 ? _b : 0,
        decisionCriteriaScore: (_c = decodeInt64(o['decisionCriteriaScore'])) !== null && _c !== void 0 ? _c : 0,
        decisionProcessScore: (_d = decodeInt64(o['decisionProcessScore'])) !== null && _d !== void 0 ? _d : 0,
        paperScore: (_e = decodeInt64(o['paperScore'])) !== null && _e !== void 0 ? _e : 0,
        identifyPainScore: (_f = decodeInt64(o['identifyPainScore'])) !== null && _f !== void 0 ? _f : 0,
        championScore: (_g = decodeInt64(o['championScore'])) !== null && _g !== void 0 ? _g : 0,
        explanations: ((_h = o['explanations']) !== null && _h !== void 0 ? _h : []).map(e => explanationFromJson(e)),
        competitionScore: (_j = decodeInt64(o['competitionScore'])) !== null && _j !== void 0 ? _j : 0,
    };
}
export function sandlerScoresToJson(m) {
    const o = {};
    if (m.bondingAndRapportScore !== undefined)
        o['bondingAndRapportScore'] = m.bondingAndRapportScore;
    if (m.upFrontContractScore !== undefined)
        o['upFrontContractScore'] = m.upFrontContractScore;
    if (m.painScore !== undefined)
        o['painScore'] = m.painScore;
    if (m.budgetScore !== undefined)
        o['budgetScore'] = m.budgetScore;
    if (m.decisionScore !== undefined)
        o['decisionScore'] = m.decisionScore;
    if (m.fulfillmentScore !== undefined)
        o['fulfillmentScore'] = m.fulfillmentScore;
    if (m.postSellScore !== undefined)
        o['postSellScore'] = m.postSellScore;
    if (m.explanations !== undefined) {
        o['explanations'] = m.explanations.map(e => explanationToJson(e));
    }
    return o;
}
export function sandlerScoresFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        bondingAndRapportScore: (_a = decodeInt64(o['bondingAndRapportScore'])) !== null && _a !== void 0 ? _a : 0,
        upFrontContractScore: (_b = decodeInt64(o['upFrontContractScore'])) !== null && _b !== void 0 ? _b : 0,
        painScore: (_c = decodeInt64(o['painScore'])) !== null && _c !== void 0 ? _c : 0,
        budgetScore: (_d = decodeInt64(o['budgetScore'])) !== null && _d !== void 0 ? _d : 0,
        decisionScore: (_e = decodeInt64(o['decisionScore'])) !== null && _e !== void 0 ? _e : 0,
        fulfillmentScore: (_f = decodeInt64(o['fulfillmentScore'])) !== null && _f !== void 0 ? _f : 0,
        postSellScore: (_g = decodeInt64(o['postSellScore'])) !== null && _g !== void 0 ? _g : 0,
        explanations: ((_h = o['explanations']) !== null && _h !== void 0 ? _h : []).map(e => explanationFromJson(e)),
    };
}
export function solutionSellingScoresToJson(m) {
    const o = {};
    if (m.situationKnowledge !== undefined)
        o['situationKnowledge'] = m.situationKnowledge;
    if (m.capabilityKnowledge !== undefined)
        o['capabilityKnowledge'] = m.capabilityKnowledge;
    if (m.peopleSkills !== undefined)
        o['peopleSkills'] = m.peopleSkills;
    if (m.sellingSkills !== undefined)
        o['sellingSkills'] = m.sellingSkills;
    if (m.explanations !== undefined) {
        o['explanations'] = m.explanations.map(e => explanationToJson(e));
    }
    return o;
}
export function solutionSellingScoresFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        situationKnowledge: (_a = decodeInt64(o['situationKnowledge'])) !== null && _a !== void 0 ? _a : 0,
        capabilityKnowledge: (_b = decodeInt64(o['capabilityKnowledge'])) !== null && _b !== void 0 ? _b : 0,
        peopleSkills: (_c = decodeInt64(o['peopleSkills'])) !== null && _c !== void 0 ? _c : 0,
        sellingSkills: (_d = decodeInt64(o['sellingSkills'])) !== null && _d !== void 0 ? _d : 0,
        explanations: ((_e = o['explanations']) !== null && _e !== void 0 ? _e : []).map(e => explanationFromJson(e)),
    };
}
export function salesMethodologyToJson(m) {
    const o = {};
    if (m.bant !== undefined)
        o['bant'] = bANTScoresToJson(m.bant);
    if (m.medpicc !== undefined)
        o['medpicc'] = mEDPICCScoresToJson(m.medpicc);
    if (m.sandler !== undefined)
        o['sandler'] = sandlerScoresToJson(m.sandler);
    if (m.ravenFramework !== undefined)
        o['ravenFramework'] = ravenFrameworkToJson(m.ravenFramework);
    if (m.solutionSelling !== undefined)
        o['solutionSelling'] = solutionSellingScoresToJson(m.solutionSelling);
    return o;
}
export function salesMethodologyFromJson(o) {
    return {
        bant: o['bant'] ? bANTScoresFromJson(o['bant']) : undefined,
        medpicc: o['medpicc'] ? mEDPICCScoresFromJson(o['medpicc']) : undefined,
        sandler: o['sandler'] ? sandlerScoresFromJson(o['sandler']) : undefined,
        ravenFramework: o['ravenFramework'] ? ravenFrameworkFromJson(o['ravenFramework']) : undefined,
        solutionSelling: o['solutionSelling'] ? solutionSellingScoresFromJson(o['solutionSelling']) : undefined,
    };
}
export function recommendationToJson(m) {
    const o = {};
    if (m.observation !== undefined)
        o['observation'] = m.observation;
    if (m.whyItMatters !== undefined)
        o['whyItMatters'] = m.whyItMatters;
    if (m.coachingAdvice !== undefined)
        o['coachingAdvice'] = m.coachingAdvice;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp;
    return o;
}
export function recommendationFromJson(o) {
    var _a, _b, _c, _d;
    return {
        observation: (_a = o['observation']) !== null && _a !== void 0 ? _a : '',
        whyItMatters: (_b = o['whyItMatters']) !== null && _b !== void 0 ? _b : '',
        coachingAdvice: (_c = o['coachingAdvice']) !== null && _c !== void 0 ? _c : '',
        timestamp: (_d = o['timestamp']) !== null && _d !== void 0 ? _d : 0,
    };
}
export function attendeesToJson(m) {
    const o = {};
    if (m.internalAttendees !== undefined) {
        o['internalAttendees'] = m.internalAttendees.map(e => e);
    }
    if (m.externalAttendees !== undefined) {
        o['externalAttendees'] = m.externalAttendees.map(e => externalAttendeeToJson(e));
    }
    return o;
}
export function attendeesFromJson(o) {
    var _a, _b;
    return {
        internalAttendees: ((_a = o['internalAttendees']) !== null && _a !== void 0 ? _a : []).map(e => e),
        externalAttendees: ((_b = o['externalAttendees']) !== null && _b !== void 0 ? _b : []).map(e => externalAttendeeFromJson(e)),
    };
}
export function sharingToJson(m) {
    const o = {};
    if (m.publicId !== undefined)
        o['publicId'] = m.publicId;
    if (m.allowPublicAccess !== undefined)
        o['allowPublicAccess'] = m.allowPublicAccess;
    if (m.publicUrl !== undefined)
        o['publicUrl'] = m.publicUrl;
    return o;
}
export function sharingFromJson(o) {
    var _a, _b, _c;
    return {
        publicId: (_a = o['publicId']) !== null && _a !== void 0 ? _a : '',
        allowPublicAccess: (_b = o['allowPublicAccess']) !== null && _b !== void 0 ? _b : false,
        publicUrl: (_c = o['publicUrl']) !== null && _c !== void 0 ? _c : '',
    };
}
export function conversationToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.externalId !== undefined)
        o['externalId'] = m.externalId;
    if (m.source !== undefined)
        o['source'] = m.source;
    if (m.rawTranscript !== undefined)
        o['rawTranscript'] = m.rawTranscript;
    if (m.recordingUrl !== undefined)
        o['recordingUrl'] = m.recordingUrl;
    if (m.meetingDate !== undefined)
        o['meetingDate'] = m.meetingDate.toISOString();
    if (m.internalAttendees !== undefined) {
        o['internalAttendees'] = m.internalAttendees.map(e => e);
    }
    if (m.externalAttendees !== undefined) {
        o['externalAttendees'] = m.externalAttendees.map(e => externalAttendeeToJson(e));
    }
    if (m.title !== undefined)
        o['title'] = m.title;
    if (m.summary !== undefined)
        o['summary'] = m.summary;
    if (m.keywords !== undefined) {
        o['keywords'] = m.keywords.map(e => e);
    }
    if (m.keyTakeaways !== undefined) {
        o['keyTakeaways'] = m.keyTakeaways.map(e => e);
    }
    if (m.actionItems !== undefined) {
        o['actionItems'] = m.actionItems.map(e => e);
    }
    if (m.sentiment !== undefined)
        o['sentiment'] = m.sentiment;
    if (m.sentimentExplanation !== undefined)
        o['sentimentExplanation'] = m.sentimentExplanation;
    if (m.salesScore !== undefined)
        o['salesScore'] = m.salesScore;
    if (m.salesScoreExplanation !== undefined)
        o['salesScoreExplanation'] = m.salesScoreExplanation;
    if (m.analysingModelUsed !== undefined)
        o['analysingModelUsed'] = m.analysingModelUsed;
    if (m.promptUsed !== undefined)
        o['promptUsed'] = m.promptUsed;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    if (m.duration !== undefined)
        o['duration'] = m.duration;
    if (m.transcriptEntries !== undefined) {
        o['transcriptEntries'] = m.transcriptEntries.map(e => transcriptEntryToJson(e));
    }
    if (m.hostUserId !== undefined)
        o['hostUserId'] = m.hostUserId;
    if (m.crmMeetingActivity !== undefined)
        o['crmMeetingActivity'] = m.crmMeetingActivity;
    if (m.topicsDiscussed !== undefined) {
        o['topicsDiscussed'] = m.topicsDiscussed.map(e => topicToJson(e));
    }
    if (m.actionItemsV2 !== undefined) {
        o['actionItemsV2'] = m.actionItemsV2.map(e => actionItemToJson(e));
    }
    if (m.highlights !== undefined) {
        o['highlights'] = m.highlights.map(e => highlightToJson(e));
    }
    if (m.lowlights !== undefined) {
        o['lowlights'] = m.lowlights.map(e => lowlightToJson(e));
    }
    if (m.businessInformation !== undefined)
        o['businessInformation'] = businessInfoToJson(m.businessInformation);
    if (m.topNeeds !== undefined) {
        o['topNeeds'] = m.topNeeds.map(e => needToJson(e));
    }
    if (m.topPainPoints !== undefined) {
        o['topPainPoints'] = m.topPainPoints.map(e => painPointToJson(e));
    }
    if (m.topSellingOpportunities !== undefined) {
        o['topSellingOpportunities'] = m.topSellingOpportunities.map(e => sellingOpportunityToJson(e));
    }
    if (m.topRedFlags !== undefined) {
        o['topRedFlags'] = m.topRedFlags.map(e => redFlagToJson(e));
    }
    if (m.currentTechStack !== undefined) {
        o['currentTechStack'] = m.currentTechStack.map(e => techStackToJson(e));
    }
    if (m.alternativeTechStack !== undefined) {
        o['alternativeTechStack'] = m.alternativeTechStack.map(e => alternativeTechToJson(e));
    }
    if (m.keywordsV2 !== undefined) {
        o['keywordsV2'] = m.keywordsV2.map(e => keywordToJson(e));
    }
    if (m.topHostQuestions !== undefined) {
        o['topHostQuestions'] = m.topHostQuestions.map(e => questionToJson(e));
    }
    if (m.topGuestQuestions !== undefined) {
        o['topGuestQuestions'] = m.topGuestQuestions.map(e => questionToJson(e));
    }
    if (m.strengths !== undefined) {
        o['strengths'] = m.strengths.map(e => strengthToJson(e));
    }
    if (m.interactionReport !== undefined)
        o['interactionReport'] = interactionReportToJson(m.interactionReport);
    if (m.clarityReport !== undefined)
        o['clarityReport'] = clarityReportToJson(m.clarityReport);
    if (m.salesMethodology !== undefined)
        o['salesMethodology'] = salesMethodologyToJson(m.salesMethodology);
    if (m.recommendations !== undefined) {
        o['recommendations'] = m.recommendations.map(e => recommendationToJson(e));
    }
    if (m.privacyLevel !== undefined)
        o['privacyLevel'] = m.privacyLevel;
    if (m.meetingType !== undefined)
        o['meetingType'] = m.meetingType;
    if (m.creatorUserId !== undefined)
        o['creatorUserId'] = m.creatorUserId;
    if (m.context !== undefined)
        o['context'] = m.context;
    if (m.sharing !== undefined)
        o['sharing'] = sharingToJson(m.sharing);
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.recordingMediaType !== undefined)
        o['recordingMediaType'] = m.recordingMediaType;
    return o;
}
export function conversationFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: (_b = o['namespace']) !== null && _b !== void 0 ? _b : '',
        externalId: (_c = o['externalId']) !== null && _c !== void 0 ? _c : '',
        source: (_d = o['source']) !== null && _d !== void 0 ? _d : 'CONVERSATION_SOURCE_UNSPECIFIED',
        rawTranscript: (_e = o['rawTranscript']) !== null && _e !== void 0 ? _e : '',
        recordingUrl: (_f = o['recordingUrl']) !== null && _f !== void 0 ? _f : '',
        meetingDate: o['meetingDate'] ? new Date(o['meetingDate']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        internalAttendees: ((_g = o['internalAttendees']) !== null && _g !== void 0 ? _g : []).map(e => e),
        externalAttendees: ((_h = o['externalAttendees']) !== null && _h !== void 0 ? _h : []).map(e => externalAttendeeFromJson(e)),
        title: (_j = o['title']) !== null && _j !== void 0 ? _j : '',
        summary: (_k = o['summary']) !== null && _k !== void 0 ? _k : '',
        keywords: ((_l = o['keywords']) !== null && _l !== void 0 ? _l : []).map(e => e),
        keyTakeaways: ((_m = o['keyTakeaways']) !== null && _m !== void 0 ? _m : []).map(e => e),
        actionItems: ((_o = o['actionItems']) !== null && _o !== void 0 ? _o : []).map(e => e),
        sentiment: (_p = decodeInt64(o['sentiment'])) !== null && _p !== void 0 ? _p : 0,
        sentimentExplanation: (_q = o['sentimentExplanation']) !== null && _q !== void 0 ? _q : '',
        salesScore: (_r = decodeInt64(o['salesScore'])) !== null && _r !== void 0 ? _r : 0,
        salesScoreExplanation: (_s = o['salesScoreExplanation']) !== null && _s !== void 0 ? _s : '',
        analysingModelUsed: (_t = o['analysingModelUsed']) !== null && _t !== void 0 ? _t : '',
        promptUsed: (_u = o['promptUsed']) !== null && _u !== void 0 ? _u : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        duration: (_v = o['duration']) !== null && _v !== void 0 ? _v : '',
        transcriptEntries: ((_w = o['transcriptEntries']) !== null && _w !== void 0 ? _w : []).map(e => transcriptEntryFromJson(e)),
        hostUserId: (_x = o['hostUserId']) !== null && _x !== void 0 ? _x : '',
        crmMeetingActivity: (_y = o['crmMeetingActivity']) !== null && _y !== void 0 ? _y : '',
        topicsDiscussed: ((_z = o['topicsDiscussed']) !== null && _z !== void 0 ? _z : []).map(e => topicFromJson(e)),
        actionItemsV2: ((_0 = o['actionItemsV2']) !== null && _0 !== void 0 ? _0 : []).map(e => actionItemFromJson(e)),
        highlights: ((_1 = o['highlights']) !== null && _1 !== void 0 ? _1 : []).map(e => highlightFromJson(e)),
        lowlights: ((_2 = o['lowlights']) !== null && _2 !== void 0 ? _2 : []).map(e => lowlightFromJson(e)),
        businessInformation: o['businessInformation'] ? businessInfoFromJson(o['businessInformation']) : undefined,
        topNeeds: ((_3 = o['topNeeds']) !== null && _3 !== void 0 ? _3 : []).map(e => needFromJson(e)),
        topPainPoints: ((_4 = o['topPainPoints']) !== null && _4 !== void 0 ? _4 : []).map(e => painPointFromJson(e)),
        topSellingOpportunities: ((_5 = o['topSellingOpportunities']) !== null && _5 !== void 0 ? _5 : []).map(e => sellingOpportunityFromJson(e)),
        topRedFlags: ((_6 = o['topRedFlags']) !== null && _6 !== void 0 ? _6 : []).map(e => redFlagFromJson(e)),
        currentTechStack: ((_7 = o['currentTechStack']) !== null && _7 !== void 0 ? _7 : []).map(e => techStackFromJson(e)),
        alternativeTechStack: ((_8 = o['alternativeTechStack']) !== null && _8 !== void 0 ? _8 : []).map(e => alternativeTechFromJson(e)),
        keywordsV2: ((_9 = o['keywordsV2']) !== null && _9 !== void 0 ? _9 : []).map(e => keywordFromJson(e)),
        topHostQuestions: ((_10 = o['topHostQuestions']) !== null && _10 !== void 0 ? _10 : []).map(e => questionFromJson(e)),
        topGuestQuestions: ((_11 = o['topGuestQuestions']) !== null && _11 !== void 0 ? _11 : []).map(e => questionFromJson(e)),
        strengths: ((_12 = o['strengths']) !== null && _12 !== void 0 ? _12 : []).map(e => strengthFromJson(e)),
        interactionReport: o['interactionReport'] ? interactionReportFromJson(o['interactionReport']) : undefined,
        clarityReport: o['clarityReport'] ? clarityReportFromJson(o['clarityReport']) : undefined,
        salesMethodology: o['salesMethodology'] ? salesMethodologyFromJson(o['salesMethodology']) : undefined,
        recommendations: ((_13 = o['recommendations']) !== null && _13 !== void 0 ? _13 : []).map(e => recommendationFromJson(e)),
        privacyLevel: (_14 = o['privacyLevel']) !== null && _14 !== void 0 ? _14 : 'PRIVACY_LEVEL_UNSPECIFIED',
        meetingType: (_15 = o['meetingType']) !== null && _15 !== void 0 ? _15 : 'MEETING_TYPE_UNSPECIFIED',
        creatorUserId: (_16 = o['creatorUserId']) !== null && _16 !== void 0 ? _16 : '',
        context: (_17 = o['context']) !== null && _17 !== void 0 ? _17 : 'SALES_COACH_CONFIG_CONTEXT_UNSET',
        sharing: o['sharing'] ? sharingFromJson(o['sharing']) : undefined,
        status: (_18 = o['status']) !== null && _18 !== void 0 ? _18 : 'CONVERSATION_STATUS_UNSET',
        recordingMediaType: (_19 = o['recordingMediaType']) !== null && _19 !== void 0 ? _19 : 'MEDIA_TYPE_INVALID',
    };
}
export function publicConversationToJson(m) {
    const o = {};
    if (m.summary !== undefined)
        o['summary'] = m.summary;
    if (m.actionItems !== undefined) {
        o['actionItems'] = m.actionItems.map(e => actionItemToJson(e));
    }
    if (m.topicsDiscussed !== undefined) {
        o['topicsDiscussed'] = m.topicsDiscussed.map(e => topicToJson(e));
    }
    if (m.transcriptEntries !== undefined) {
        o['transcriptEntries'] = m.transcriptEntries.map(e => transcriptEntryToJson(e));
    }
    if (m.title !== undefined)
        o['title'] = m.title;
    if (m.meetingDate !== undefined)
        o['meetingDate'] = m.meetingDate.toISOString();
    if (m.duration !== undefined)
        o['duration'] = m.duration;
    if (m.source !== undefined)
        o['source'] = m.source;
    return o;
}
export function publicConversationFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        summary: (_a = o['summary']) !== null && _a !== void 0 ? _a : '',
        actionItems: ((_b = o['actionItems']) !== null && _b !== void 0 ? _b : []).map(e => actionItemFromJson(e)),
        topicsDiscussed: ((_c = o['topicsDiscussed']) !== null && _c !== void 0 ? _c : []).map(e => topicFromJson(e)),
        transcriptEntries: ((_d = o['transcriptEntries']) !== null && _d !== void 0 ? _d : []).map(e => transcriptEntryFromJson(e)),
        title: (_e = o['title']) !== null && _e !== void 0 ? _e : '',
        meetingDate: o['meetingDate'] ? new Date(o['meetingDate']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        duration: (_f = o['duration']) !== null && _f !== void 0 ? _f : '',
        source: (_g = o['source']) !== null && _g !== void 0 ? _g : 'CONVERSATION_SOURCE_UNSPECIFIED',
    };
}
export function eventParticipantToJson(m) {
    const o = {};
    if (m.displayName !== undefined)
        o['displayName'] = m.displayName;
    if (m.email !== undefined)
        o['email'] = m.email;
    return o;
}
export function eventParticipantFromJson(o) {
    var _a, _b;
    return {
        displayName: (_a = o['displayName']) !== null && _a !== void 0 ? _a : '',
        email: (_b = o['email']) !== null && _b !== void 0 ? _b : '',
    };
}
export function privacyOverrideToJson(m) {
    const o = {};
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.privacyLevel !== undefined)
        o['privacyLevel'] = m.privacyLevel;
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    return o;
}
export function privacyOverrideFromJson(o) {
    var _a, _b;
    return {
        userId: (_a = o['userId']) !== null && _a !== void 0 ? _a : '',
        privacyLevel: (_b = o['privacyLevel']) !== null && _b !== void 0 ? _b : 'PRIVACY_LEVEL_UNSPECIFIED',
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function meetingBotToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.context !== undefined)
        o['context'] = m.context;
    if (m.externalBotId !== undefined)
        o['externalBotId'] = m.externalBotId;
    if (m.userIds !== undefined) {
        o['userIds'] = m.userIds.map(e => e);
    }
    if (m.source !== undefined)
        o['source'] = m.source;
    if (m.eventId !== undefined)
        o['eventId'] = m.eventId;
    if (m.eventStartTime !== undefined)
        o['eventStartTime'] = m.eventStartTime.toISOString();
    if (m.eventTitle !== undefined)
        o['eventTitle'] = m.eventTitle;
    if (m.eventDescription !== undefined)
        o['eventDescription'] = m.eventDescription;
    if (m.eventInvitees !== undefined) {
        o['eventInvitees'] = m.eventInvitees.map(e => eventParticipantToJson(e));
    }
    if (m.eventCreator !== undefined)
        o['eventCreator'] = eventParticipantToJson(m.eventCreator);
    if (m.eventOrganizer !== undefined)
        o['eventOrganizer'] = eventParticipantToJson(m.eventOrganizer);
    if (m.meetingId !== undefined)
        o['meetingId'] = m.meetingId;
    if (m.meetingUrl !== undefined)
        o['meetingUrl'] = m.meetingUrl;
    if (m.noteTakerName !== undefined)
        o['noteTakerName'] = m.noteTakerName;
    if (m.showRecordingConsentMessages !== undefined)
        o['showRecordingConsentMessages'] = m.showRecordingConsentMessages;
    if (m.privacyOverride !== undefined)
        o['privacyOverride'] = privacyOverrideToJson(m.privacyOverride);
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    return o;
}
export function meetingBotFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: (_b = o['namespace']) !== null && _b !== void 0 ? _b : '',
        context: (_c = o['context']) !== null && _c !== void 0 ? _c : 'SALES_COACH_CONFIG_CONTEXT_UNSET',
        externalBotId: (_d = o['externalBotId']) !== null && _d !== void 0 ? _d : '',
        userIds: ((_e = o['userIds']) !== null && _e !== void 0 ? _e : []).map(e => e),
        source: (_f = o['source']) !== null && _f !== void 0 ? _f : 'SOURCE_UNSPECIFIED',
        eventId: (_g = o['eventId']) !== null && _g !== void 0 ? _g : '',
        eventStartTime: o['eventStartTime'] ? new Date(o['eventStartTime']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        eventTitle: (_h = o['eventTitle']) !== null && _h !== void 0 ? _h : '',
        eventDescription: (_j = o['eventDescription']) !== null && _j !== void 0 ? _j : '',
        eventInvitees: ((_k = o['eventInvitees']) !== null && _k !== void 0 ? _k : []).map(e => eventParticipantFromJson(e)),
        eventCreator: o['eventCreator'] ? eventParticipantFromJson(o['eventCreator']) : undefined,
        eventOrganizer: o['eventOrganizer'] ? eventParticipantFromJson(o['eventOrganizer']) : undefined,
        meetingId: (_l = o['meetingId']) !== null && _l !== void 0 ? _l : '',
        meetingUrl: (_m = o['meetingUrl']) !== null && _m !== void 0 ? _m : '',
        noteTakerName: (_o = o['noteTakerName']) !== null && _o !== void 0 ? _o : '',
        showRecordingConsentMessages: (_p = o['showRecordingConsentMessages']) !== null && _p !== void 0 ? _p : false,
        privacyOverride: o['privacyOverride'] ? privacyOverrideFromJson(o['privacyOverride']) : undefined,
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function salesCoachConfigToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.context !== undefined)
        o['context'] = m.context;
    if (m.joinMeetings !== undefined)
        o['joinMeetings'] = m.joinMeetings;
    if (m.notetakerName !== undefined)
        o['notetakerName'] = m.notetakerName;
    if (m.showRecordingConsentMessages !== undefined)
        o['showRecordingConsentMessages'] = m.showRecordingConsentMessages;
    if (m.hasSalesCoachingAccess !== undefined)
        o['hasSalesCoachingAccess'] = m.hasSalesCoachingAccess;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    return o;
}
export function salesCoachConfigFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: (_b = o['namespace']) !== null && _b !== void 0 ? _b : '',
        context: (_c = o['context']) !== null && _c !== void 0 ? _c : 'SALES_COACH_CONFIG_CONTEXT_UNSET',
        joinMeetings: (_d = o['joinMeetings']) !== null && _d !== void 0 ? _d : false,
        notetakerName: (_e = o['notetakerName']) !== null && _e !== void 0 ? _e : '',
        showRecordingConsentMessages: (_f = o['showRecordingConsentMessages']) !== null && _f !== void 0 ? _f : false,
        hasSalesCoachingAccess: (_g = o['hasSalesCoachingAccess']) !== null && _g !== void 0 ? _g : false,
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function salesCoachUserConfigToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.joinMeetings !== undefined)
        o['joinMeetings'] = m.joinMeetings;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    if (m.privacy !== undefined)
        o['privacy'] = privacyToJson(m.privacy);
    if (m.context !== undefined)
        o['context'] = m.context;
    return o;
}
export function salesCoachUserConfigFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        joinMeetings: (_c = o['joinMeetings']) !== null && _c !== void 0 ? _c : false,
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        privacy: o['privacy'] ? privacyFromJson(o['privacy']) : undefined,
        context: (_d = o['context']) !== null && _d !== void 0 ? _d : 'SALES_COACH_CONFIG_CONTEXT_UNSET',
    };
}
export function listConversationsRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = listConversationsRequestFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.sort !== undefined)
        o['sort'] = listConversationsRequestSortToJson(m.sort);
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function listConversationsRequestFromJson(o) {
    var _a, _b;
    return {
        filters: o['filters'] ? listConversationsRequestFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        sort: o['sort'] ? listConversationsRequestSortFromJson(o['sort']) : undefined,
        searchTerm: (_a = o['searchTerm']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listConversationsRequestFiltersToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.source !== undefined)
        o['source'] = m.source;
    if (m.keywords !== undefined) {
        o['keywords'] = m.keywords.map(e => e);
    }
    if (m.sentiment !== undefined)
        o['sentiment'] = m.sentiment;
    if (m.salesScore !== undefined)
        o['salesScore'] = m.salesScore;
    if (m.host !== undefined)
        o['host'] = m.host;
    if (m.creator !== undefined)
        o['creator'] = m.creator;
    if (m.contactIds !== undefined) {
        o['contactIds'] = m.contactIds.map(e => e);
    }
    if (m.internalAttendees !== undefined) {
        o['internalAttendees'] = m.internalAttendees.map(e => e);
    }
    if (m.privacyLevel !== undefined)
        o['privacyLevel'] = m.privacyLevel;
    if (m.startTimeAfter !== undefined)
        o['startTimeAfter'] = m.startTimeAfter.toISOString();
    if (m.startTimeBefore !== undefined)
        o['startTimeBefore'] = m.startTimeBefore.toISOString();
    if (m.externalId !== undefined)
        o['externalId'] = m.externalId;
    if (m.status !== undefined)
        o['status'] = m.status;
    return o;
}
export function listConversationsRequestFiltersFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        source: (_b = o['source']) !== null && _b !== void 0 ? _b : 'CONVERSATION_SOURCE_UNSPECIFIED',
        keywords: ((_c = o['keywords']) !== null && _c !== void 0 ? _c : []).map(e => e),
        sentiment: (_d = decodeInt64(o['sentiment'])) !== null && _d !== void 0 ? _d : 0,
        salesScore: (_e = decodeInt64(o['salesScore'])) !== null && _e !== void 0 ? _e : 0,
        host: (_f = o['host']) !== null && _f !== void 0 ? _f : '',
        creator: (_g = o['creator']) !== null && _g !== void 0 ? _g : '',
        contactIds: ((_h = o['contactIds']) !== null && _h !== void 0 ? _h : []).map(e => e),
        internalAttendees: ((_j = o['internalAttendees']) !== null && _j !== void 0 ? _j : []).map(e => e),
        privacyLevel: (_k = o['privacyLevel']) !== null && _k !== void 0 ? _k : 'PRIVACY_LEVEL_UNSPECIFIED',
        startTimeAfter: o['startTimeAfter'] ? new Date(o['startTimeAfter']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        startTimeBefore: o['startTimeBefore'] ? new Date(o['startTimeBefore']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        externalId: (_l = o['externalId']) !== null && _l !== void 0 ? _l : '',
        status: (_m = o['status']) !== null && _m !== void 0 ? _m : 'CONVERSATION_STATUS_UNSET',
    };
}
export function listConversationsRequestSortToJson(m) {
    const o = {};
    if (m.field !== undefined)
        o['field'] = m.field;
    if (m.direction !== undefined)
        o['direction'] = m.direction;
    return o;
}
export function listConversationsRequestSortFromJson(o) {
    var _a, _b;
    return {
        field: (_a = o['field']) !== null && _a !== void 0 ? _a : 'CONVERSATION_SORT_FIELD_UNSPECIFIED',
        direction: (_b = o['direction']) !== null && _b !== void 0 ? _b : 'SORT_DIRECTION_UNSET',
    };
}
export function listConversationsResponseToJson(m) {
    const o = {};
    if (m.conversations !== undefined) {
        o['conversations'] = m.conversations.map(e => conversationToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listConversationsResponseFromJson(o) {
    var _a;
    return {
        conversations: ((_a = o['conversations']) !== null && _a !== void 0 ? _a : []).map(e => conversationFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function getConversationRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function getConversationRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getConversationResponseToJson(m) {
    const o = {};
    if (m.conversation !== undefined)
        o['conversation'] = conversationToJson(m.conversation);
    return o;
}
export function getConversationResponseFromJson(o) {
    return {
        conversation: o['conversation'] ? conversationFromJson(o['conversation']) : undefined,
    };
}
export function createEvaluationRequestToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.feedback !== undefined)
        o['feedback'] = m.feedback;
    if (m.comment !== undefined)
        o['comment'] = m.comment;
    if (m.reasons !== undefined) {
        o['reasons'] = m.reasons.map(e => e);
    }
    return o;
}
export function createEvaluationRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
        feedback: (_b = o['feedback']) !== null && _b !== void 0 ? _b : 'EVALUATION_FEEDBACK_UNDEFINED',
        comment: (_c = o['comment']) !== null && _c !== void 0 ? _c : '',
        reasons: ((_d = o['reasons']) !== null && _d !== void 0 ? _d : []).map(e => e),
    };
}
export function createConversationRequestToJson(m) {
    const o = {};
    if (m.conversation !== undefined)
        o['conversation'] = conversationToJson(m.conversation);
    return o;
}
export function createConversationRequestFromJson(o) {
    return {
        conversation: o['conversation'] ? conversationFromJson(o['conversation']) : undefined,
    };
}
export function createConversationResponseToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function createConversationResponseFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updateConversationRequestToJson(m) {
    const o = {};
    if (m.conversation !== undefined)
        o['conversation'] = conversationToJson(m.conversation);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateConversationRequestFromJson(o) {
    return {
        conversation: o['conversation'] ? conversationFromJson(o['conversation']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function getRecordingURLRequestToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    return o;
}
export function getRecordingURLRequestFromJson(o) {
    var _a;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getRecordingURLResponseToJson(m) {
    const o = {};
    if (m.recordingUrl !== undefined)
        o['recordingUrl'] = m.recordingUrl;
    return o;
}
export function getRecordingURLResponseFromJson(o) {
    var _a;
    return {
        recordingUrl: (_a = o['recordingUrl']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getPublicRecordingURLRequestToJson(m) {
    const o = {};
    if (m.publicId !== undefined)
        o['publicId'] = m.publicId;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    return o;
}
export function getPublicRecordingURLRequestFromJson(o) {
    var _a, _b;
    return {
        publicId: (_a = o['publicId']) !== null && _a !== void 0 ? _a : '',
        namespace: (_b = o['namespace']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getPublicRecordingURLResponseToJson(m) {
    const o = {};
    if (m.recordingUrl !== undefined)
        o['recordingUrl'] = m.recordingUrl;
    if (m.mediaType !== undefined)
        o['mediaType'] = m.mediaType;
    return o;
}
export function getPublicRecordingURLResponseFromJson(o) {
    var _a, _b;
    return {
        recordingUrl: (_a = o['recordingUrl']) !== null && _a !== void 0 ? _a : '',
        mediaType: (_b = o['mediaType']) !== null && _b !== void 0 ? _b : 'MEDIA_TYPE_INVALID',
    };
}
export function getPublicConversationRequestToJson(m) {
    const o = {};
    if (m.publicId !== undefined)
        o['publicId'] = m.publicId;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    return o;
}
export function getPublicConversationRequestFromJson(o) {
    var _a, _b;
    return {
        publicId: (_a = o['publicId']) !== null && _a !== void 0 ? _a : '',
        namespace: (_b = o['namespace']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getPublicConversationResponseToJson(m) {
    const o = {};
    if (m.conversation !== undefined)
        o['conversation'] = publicConversationToJson(m.conversation);
    return o;
}
export function getPublicConversationResponseFromJson(o) {
    return {
        conversation: o['conversation'] ? publicConversationFromJson(o['conversation']) : undefined,
    };
}
export function listKeywordsForConversationsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    return o;
}
export function listKeywordsForConversationsRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        searchTerm: (_c = o['searchTerm']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listKeywordsForConversationsResponseToJson(m) {
    const o = {};
    if (m.keywords !== undefined) {
        o['keywords'] = m.keywords.map(e => e);
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listKeywordsForConversationsResponseFromJson(o) {
    var _a;
    return {
        keywords: ((_a = o['keywords']) !== null && _a !== void 0 ? _a : []).map(e => e),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function enablePublicSharingRequestToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    return o;
}
export function enablePublicSharingRequestFromJson(o) {
    var _a;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function disablePublicSharingRequestToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    return o;
}
export function disablePublicSharingRequestFromJson(o) {
    var _a;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function enablePublicSharingResponseToJson(m) {
    const o = {};
    if (m.sharing !== undefined)
        o['sharing'] = sharingToJson(m.sharing);
    return o;
}
export function enablePublicSharingResponseFromJson(o) {
    return {
        sharing: o['sharing'] ? sharingFromJson(o['sharing']) : undefined,
    };
}
export function analyzeUploadedRecordingRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.audioUrl !== undefined)
        o['audioUrl'] = m.audioUrl;
    if (m.contactIds !== undefined) {
        o['contactIds'] = m.contactIds.map(e => e);
    }
    if (m.meetingDate !== undefined)
        o['meetingDate'] = m.meetingDate.toISOString();
    if (m.context !== undefined)
        o['context'] = m.context;
    return o;
}
export function analyzeUploadedRecordingRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        audioUrl: (_b = o['audioUrl']) !== null && _b !== void 0 ? _b : '',
        contactIds: ((_c = o['contactIds']) !== null && _c !== void 0 ? _c : []).map(e => e),
        meetingDate: o['meetingDate'] ? new Date(o['meetingDate']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        context: (_d = o['context']) !== null && _d !== void 0 ? _d : 'SALES_COACH_CONFIG_CONTEXT_UNSET',
    };
}
export function analyzeUploadedRecordingResponseToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    return o;
}
export function analyzeUploadedRecordingResponseFromJson(o) {
    var _a;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function identifiedSpeakerToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.type !== undefined)
        o['type'] = m.type;
    return o;
}
export function identifiedSpeakerFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        type: (_b = o['type']) !== null && _b !== void 0 ? _b : 'ASSIGNEE_TYPE_INVALID',
    };
}
export function speakerAssignmentToJson(m) {
    const o = {};
    if (m.newIdentity !== undefined)
        o['newIdentity'] = identifiedSpeakerToJson(m.newIdentity);
    if (m.currentSpeaker !== undefined) {
        if (m.currentSpeaker.type === 'speakerName') {
            o['speakerName'] = m.currentSpeaker.speakerName;
        }
        if (m.currentSpeaker.type === 'currentIdentified') {
            o['currentIdentified'] = identifiedSpeakerToJson(m.currentSpeaker.currentIdentified);
        }
    }
    else {
        if (m.speakerName !== undefined)
            o['speakerName'] = m.speakerName;
        if (m.currentIdentified !== undefined)
            o['currentIdentified'] = identifiedSpeakerToJson(m.currentIdentified);
    }
    return o;
}
export function speakerAssignmentFromJson(o) {
    return {
        newIdentity: o['newIdentity'] ? identifiedSpeakerFromJson(o['newIdentity']) : undefined,
        currentSpeaker: (() => {
            if (o['speakerName'] !== undefined)
                return { type: 'speakerName', speakerName: o['speakerName'] };
            if (o['currentIdentified'] !== undefined)
                return { type: 'currentIdentified', currentIdentified: o['currentIdentified'] ? identifiedSpeakerFromJson(o['currentIdentified']) : undefined };
            return undefined;
        })(),
        speakerName: o['speakerName'] !== undefined ? o['speakerName'] : undefined,
        currentIdentified: o['currentIdentified'] !== undefined ? o['currentIdentified'] ? identifiedSpeakerFromJson(o['currentIdentified']) : undefined : undefined,
    };
}
export function assignParticipantsRequestToJson(m) {
    const o = {};
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.assignments !== undefined) {
        o['assignments'] = m.assignments.map(e => speakerAssignmentToJson(e));
    }
    return o;
}
export function assignParticipantsRequestFromJson(o) {
    var _a, _b, _c;
    return {
        conversationId: (_a = o['conversationId']) !== null && _a !== void 0 ? _a : '',
        namespace: (_b = o['namespace']) !== null && _b !== void 0 ? _b : '',
        assignments: ((_c = o['assignments']) !== null && _c !== void 0 ? _c : []).map(e => speakerAssignmentFromJson(e)),
    };
}
export function getSalesCoachConfigRequestToJson(m) {
    const o = {};
    if (m.lookupIds !== undefined) {
        if (m.lookupIds.type === 'id') {
            o['id'] = m.lookupIds.id;
        }
        if (m.lookupIds.type === 'namespace') {
            o['namespace'] = m.lookupIds.namespace;
        }
    }
    else {
        if (m.id !== undefined)
            o['id'] = m.id;
        if (m.namespace !== undefined)
            o['namespace'] = m.namespace;
    }
    return o;
}
export function getSalesCoachConfigRequestFromJson(o) {
    return {
        lookupIds: (() => {
            if (o['id'] !== undefined)
                return { type: 'id', id: o['id'] };
            if (o['namespace'] !== undefined)
                return { type: 'namespace', namespace: o['namespace'] };
            return undefined;
        })(),
        id: o['id'] !== undefined ? o['id'] : undefined,
        namespace: o['namespace'] !== undefined ? o['namespace'] : undefined,
    };
}
export function getSalesCoachConfigResponseToJson(m) {
    const o = {};
    if (m.salesCoachConfig !== undefined)
        o['salesCoachConfig'] = salesCoachConfigToJson(m.salesCoachConfig);
    return o;
}
export function getSalesCoachConfigResponseFromJson(o) {
    return {
        salesCoachConfig: o['salesCoachConfig'] ? salesCoachConfigFromJson(o['salesCoachConfig']) : undefined,
    };
}
export function createSalesCoachConfigRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.context !== undefined)
        o['context'] = m.context;
    if (m.joinMeetings !== undefined)
        o['joinMeetings'] = m.joinMeetings;
    if (m.notetakerName !== undefined)
        o['notetakerName'] = m.notetakerName;
    if (m.showRecordingConsentMessages !== undefined)
        o['showRecordingConsentMessages'] = m.showRecordingConsentMessages;
    if (m.hasSalesCoachingAccess !== undefined)
        o['hasSalesCoachingAccess'] = m.hasSalesCoachingAccess;
    return o;
}
export function createSalesCoachConfigRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        context: (_b = o['context']) !== null && _b !== void 0 ? _b : 'SALES_COACH_CONFIG_CONTEXT_UNSET',
        joinMeetings: (_c = o['joinMeetings']) !== null && _c !== void 0 ? _c : false,
        notetakerName: (_d = o['notetakerName']) !== null && _d !== void 0 ? _d : '',
        showRecordingConsentMessages: (_e = o['showRecordingConsentMessages']) !== null && _e !== void 0 ? _e : false,
        hasSalesCoachingAccess: (_f = o['hasSalesCoachingAccess']) !== null && _f !== void 0 ? _f : false,
    };
}
export function createSalesConfigResponseToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function createSalesConfigResponseFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updateSalesCoachConfigRequestToJson(m) {
    const o = {};
    if (m.joinMeetings !== undefined)
        o['joinMeetings'] = m.joinMeetings;
    if (m.notetakerName !== undefined)
        o['notetakerName'] = m.notetakerName;
    if (m.showRecordingConsentMessages !== undefined)
        o['showRecordingConsentMessages'] = m.showRecordingConsentMessages;
    if (m.hasSalesCoachingAccess !== undefined)
        o['hasSalesCoachingAccess'] = m.hasSalesCoachingAccess;
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    if (m.lookupIds !== undefined) {
        if (m.lookupIds.type === 'id') {
            o['id'] = m.lookupIds.id;
        }
        if (m.lookupIds.type === 'namespace') {
            o['namespace'] = m.lookupIds.namespace;
        }
    }
    else {
        if (m.id !== undefined)
            o['id'] = m.id;
        if (m.namespace !== undefined)
            o['namespace'] = m.namespace;
    }
    return o;
}
export function updateSalesCoachConfigRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        joinMeetings: (_a = o['joinMeetings']) !== null && _a !== void 0 ? _a : false,
        notetakerName: (_b = o['notetakerName']) !== null && _b !== void 0 ? _b : '',
        showRecordingConsentMessages: (_c = o['showRecordingConsentMessages']) !== null && _c !== void 0 ? _c : false,
        hasSalesCoachingAccess: (_d = o['hasSalesCoachingAccess']) !== null && _d !== void 0 ? _d : false,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
        lookupIds: (() => {
            if (o['id'] !== undefined)
                return { type: 'id', id: o['id'] };
            if (o['namespace'] !== undefined)
                return { type: 'namespace', namespace: o['namespace'] };
            return undefined;
        })(),
        id: o['id'] !== undefined ? o['id'] : undefined,
        namespace: o['namespace'] !== undefined ? o['namespace'] : undefined,
    };
}
export function deleteSalesCoachConfigRequestToJson(m) {
    const o = {};
    if (m.lookupIds !== undefined) {
        if (m.lookupIds.type === 'id') {
            o['id'] = m.lookupIds.id;
        }
        if (m.lookupIds.type === 'namespace') {
            o['namespace'] = m.lookupIds.namespace;
        }
    }
    else {
        if (m.id !== undefined)
            o['id'] = m.id;
        if (m.namespace !== undefined)
            o['namespace'] = m.namespace;
    }
    return o;
}
export function deleteSalesCoachConfigRequestFromJson(o) {
    return {
        lookupIds: (() => {
            if (o['id'] !== undefined)
                return { type: 'id', id: o['id'] };
            if (o['namespace'] !== undefined)
                return { type: 'namespace', namespace: o['namespace'] };
            return undefined;
        })(),
        id: o['id'] !== undefined ? o['id'] : undefined,
        namespace: o['namespace'] !== undefined ? o['namespace'] : undefined,
    };
}
export function upsertSalesCoachConfigRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.context !== undefined)
        o['context'] = m.context;
    if (m.joinMeetings !== undefined)
        o['joinMeetings'] = m.joinMeetings;
    if (m.notetakerName !== undefined)
        o['notetakerName'] = m.notetakerName;
    if (m.showRecordingConsentMessages !== undefined)
        o['showRecordingConsentMessages'] = m.showRecordingConsentMessages;
    if (m.hasSalesCoachingAccess !== undefined)
        o['hasSalesCoachingAccess'] = m.hasSalesCoachingAccess;
    return o;
}
export function upsertSalesCoachConfigRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        context: (_b = o['context']) !== null && _b !== void 0 ? _b : 'SALES_COACH_CONFIG_CONTEXT_UNSET',
        joinMeetings: (_c = o['joinMeetings']) !== null && _c !== void 0 ? _c : false,
        notetakerName: (_d = o['notetakerName']) !== null && _d !== void 0 ? _d : '',
        showRecordingConsentMessages: (_e = o['showRecordingConsentMessages']) !== null && _e !== void 0 ? _e : false,
        hasSalesCoachingAccess: (_f = o['hasSalesCoachingAccess']) !== null && _f !== void 0 ? _f : false,
    };
}
export function getSalesCoachUserConfigRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function getSalesCoachUserConfigRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getSalesCoachUserConfigResponseToJson(m) {
    const o = {};
    if (m.salesCoachUserConfig !== undefined)
        o['salesCoachUserConfig'] = salesCoachUserConfigToJson(m.salesCoachUserConfig);
    return o;
}
export function getSalesCoachUserConfigResponseFromJson(o) {
    return {
        salesCoachUserConfig: o['salesCoachUserConfig'] ? salesCoachUserConfigFromJson(o['salesCoachUserConfig']) : undefined,
    };
}
export function createSalesCoachUserConfigRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.joinMeetings !== undefined)
        o['joinMeetings'] = m.joinMeetings;
    if (m.privacy !== undefined)
        o['privacy'] = privacyToJson(m.privacy);
    if (m.context !== undefined)
        o['context'] = m.context;
    return o;
}
export function createSalesCoachUserConfigRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        joinMeetings: (_c = o['joinMeetings']) !== null && _c !== void 0 ? _c : false,
        privacy: o['privacy'] ? privacyFromJson(o['privacy']) : undefined,
        context: (_d = o['context']) !== null && _d !== void 0 ? _d : 'SALES_COACH_CONFIG_CONTEXT_UNSET',
    };
}
export function updateSalesCoachUserConfigRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.joinMeetings !== undefined)
        o['joinMeetings'] = m.joinMeetings;
    if (m.privacy !== undefined)
        o['privacy'] = privacyToJson(m.privacy);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateSalesCoachUserConfigRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        joinMeetings: (_c = o['joinMeetings']) !== null && _c !== void 0 ? _c : false,
        privacy: o['privacy'] ? privacyFromJson(o['privacy']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function upsertSalesCoachUserConfigRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.joinMeetings !== undefined)
        o['joinMeetings'] = m.joinMeetings;
    if (m.privacy !== undefined)
        o['privacy'] = privacyToJson(m.privacy);
    if (m.context !== undefined)
        o['context'] = m.context;
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function upsertSalesCoachUserConfigRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        joinMeetings: (_c = o['joinMeetings']) !== null && _c !== void 0 ? _c : false,
        privacy: o['privacy'] ? privacyFromJson(o['privacy']) : undefined,
        context: (_d = o['context']) !== null && _d !== void 0 ? _d : 'SALES_COACH_CONFIG_CONTEXT_UNSET',
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function deleteSalesCoachUserConfigRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function deleteSalesCoachUserConfigRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function scheduleBotRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.meetingUrl !== undefined)
        o['meetingUrl'] = m.meetingUrl;
    return o;
}
export function scheduleBotRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        meetingUrl: (_b = o['meetingUrl']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listMeetingBotsRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = listMeetingBotsRequestFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    return o;
}
export function listMeetingBotsRequestFromJson(o) {
    var _a;
    return {
        filters: o['filters'] ? listMeetingBotsRequestFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        searchTerm: (_a = o['searchTerm']) !== null && _a !== void 0 ? _a : '',
    };
}
export function listMeetingBotsRequestFiltersToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.eventStartTimeAfter !== undefined)
        o['eventStartTimeAfter'] = m.eventStartTimeAfter.toISOString();
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function listMeetingBotsRequestFiltersFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        eventStartTimeAfter: o['eventStartTimeAfter'] ? new Date(o['eventStartTimeAfter']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listMeetingBotsResponseToJson(m) {
    const o = {};
    if (m.meetingBots !== undefined) {
        o['meetingBots'] = m.meetingBots.map(e => meetingBotToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listMeetingBotsResponseFromJson(o) {
    var _a;
    return {
        meetingBots: ((_a = o['meetingBots']) !== null && _a !== void 0 ? _a : []).map(e => meetingBotFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function overridePrivacyRequestToJson(m) {
    const o = {};
    if (m.meetingBotId !== undefined)
        o['meetingBotId'] = m.meetingBotId;
    if (m.privacyLevel !== undefined)
        o['privacyLevel'] = m.privacyLevel;
    return o;
}
export function overridePrivacyRequestFromJson(o) {
    var _a, _b;
    return {
        meetingBotId: (_a = o['meetingBotId']) !== null && _a !== void 0 ? _a : '',
        privacyLevel: (_b = o['privacyLevel']) !== null && _b !== void 0 ? _b : 'PRIVACY_LEVEL_UNSPECIFIED',
    };
}
export function overridePrivacyResponseToJson(m) {
    const o = {};
    if (m.privacyOverride !== undefined)
        o['privacyOverride'] = privacyOverrideToJson(m.privacyOverride);
    return o;
}
export function overridePrivacyResponseFromJson(o) {
    return {
        privacyOverride: o['privacyOverride'] ? privacyOverrideFromJson(o['privacyOverride']) : undefined,
    };
}
